import React, { useEffect, useState } from "react";
import { Button, Card, FloatButton, Alert } from "antd";
import { css } from "@emotion/css";
import { useDispatch, useSelector } from "react-redux";

import { tokenInfoAction } from "../../store/action/admin/personalInfoAction";
import CustomLoaderIcon from "../../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon";
import CloseIcon from "../../Theme/CustomIcons/Icons/CustomIcons/CloseIcon";
import {
  createSupportTicketAction,
  getSupportTicketByIdAction,
  getSupportMesaageByTicketIdAhandleActiontion,
  getAllSupportTicketAction,
  getSupportMesaageByTicketIdAction,
} from "../../store/action/admin/supportTicketActions";
import MainMenu from "./MainMenu";
import ChatView from "./ChatView";
import Menu2 from "./Menu2";
import SupportUnreadBadge from "./SupportUnreadBadge";
import { getNotificatonAction } from "../../store/action/admin/notificationsActions";
import { onMessage } from "firebase/messaging";
import {
  // listenForegroundMessages,
  messages,
} from "../../shared-components/push-notification/index";

// --- Sub-Components ---

const SupportButton = ({ icon, label, onClick, isSmall = false }) => (
  <Button
    onClick={onClick}
    style={{
      height: "auto",
      padding: "10px 14px",
      backgroundColor: "#130f0d",
      border: "1px solid #26211e",
      color: "#d4a373",
      borderRadius: "6px",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "10px",
      width: isSmall ? "fit-content" : "100%",
    }}
  >
    {icon && <span style={{ fontSize: "13px", display: "flex" }}>{icon}</span>}
    <span style={{ fontSize: "14px", fontWeight: 400 }}>{label}</span>
  </Button>
);

const SupportWidget = ({ token = "" }) => {
  const [visible, setVisible] = useState(false);
  const [view, setView] = useState("menu"); // 'menu' or 'chat'
  const [activeCategory, setActiveCategory] = useState("");
  const [activeTicketId, setActiveTicketId] = useState("");

  const [showDummyMessage, setShowDummyMessage] = useState([]);
  const [isAiResponding, setIsAiResponding] = useState(false); // New loader state
  const [supportMessages, setSupportMessages] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [widgetError, setWidgetError] = useState(null);

  const themeDefault = useSelector((state) => state.themeDefault);
  const tokenInfoList = useSelector((state) => state.tokenInfoList);
  const getAllSupportTicketList = useSelector(
    (state) => state.getAllSupportTicketList
  );

  const dispatch = useDispatch();

  // Auto-scroll to bottom when messages update or AI is responding

  useEffect(() => {
    if (token) {
      dispatch(tokenInfoAction(token));
    }
  }, [dispatch]);

  const handleAction = async (type) => {
    try {
      setWidgetError(null);
      setSupportMessages([]);
      setIsLoader(true);
      const companyId =
        tokenInfoList?.info?.company?._id ||
        tokenInfoList?.info?.companyId?._id;
      if (!companyId) return;

      if (type?.toLowerCase() !== "other") {
        setIsAiResponding(true);
      }
      const formData = new FormData();
      formData.append("subject", type);

      const supportTicket = await dispatch(
        createSupportTicketAction(formData, token, companyId)
      );
      const ticketId = supportTicket?.data?._id;
      setActiveTicketId(ticketId);
      if (!ticketId) {
        setView("menu");
        setIsAiResponding(false);
        setActiveTicketId(null);

        return;
      }

      await dispatch(getSupportTicketByIdAction(ticketId, token, companyId));
      await dispatch(
        getSupportMesaageByTicketIdAction(ticketId, token, companyId)
      );
      setActiveCategory(type);
      setView("chat"); // Start loader
      dispatch(getNotificatonAction(companyId, token));
      setIsLoader(false);

      setIsAiResponding(false); // Stop loader
    } catch (error) {
      console.error("Error in handleAction:", error);
      setIsAiResponding(false);
      setIsLoader(false);
      setWidgetError(error.message || "Failed to perform support action");
    }
  };

  useEffect(() => {
    if (tokenInfoList?.info && token) {
      const companyId =
        tokenInfoList?.info?.company?._id ??
        tokenInfoList?.info?.companyId?._id;
      dispatch(getAllSupportTicketAction(token, companyId));
    }
  }, [tokenInfoList?.info]);

  const getCompanyId = () => {
    return (
      tokenInfoList?.info?.company?._id ||
      tokenInfoList?.info?.companyId?._id ||
      null
    );
  };

  const fetchNotifications = (companyId) => {
    dispatch(getNotificatonAction(companyId, token));
  };

  const fetchTicketMessages = (companyId) => {
    if (!activeTicketId) return;

    dispatch(
      getSupportMesaageByTicketIdAction(activeTicketId, token, companyId)
    );
  };

  const handleIncomingMessage = (payload) => {
    if (!token || !tokenInfoList?.info) return;

    const companyId = getCompanyId();
    if (!companyId) return;

    fetchNotifications(companyId);
    fetchTicketMessages(companyId);
  };

  // listenForegroundMessages(messages, handleIncomingMessage);
  useEffect(() => {
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        handleIncomingMessage(event);
      });
    }
  }, [messages, tokenInfoList?.info, activeTicketId]);

  const handleClose = async () => {
    setVisible(false);
    setView("menu");
    setActiveTicketId(null);
    setWidgetError(null);
  };

  const errorToShow = tokenInfoList?.error || getAllSupportTicketList?.error || widgetError;

  return (
    <>
      {visible && (
        <FloatButton
          shape="circle"
          className={css`
            .ant-float-btn-body {
              background: linear-gradient(
                200deg,
                ${themeDefault?.info?.newConfig?.colorPrimaryShades?.[4] ||
            "#FFBB96"},
                ${themeDefault?.info?.newConfig?.colorPrimaryShades?.[7] ||
            "#FF7A45"}
              ) !important;
            }
            width: 60px;
            height: 60px;
            animation: supportPop 0.25s ease-out;

            @keyframes supportPop {
              0% {
                transform: scale(0.6);
                opacity: 0;
              }
              60% {
                transform: scale(1.1);
                opacity: 1;
              }
              100% {
                transform: scale(1);
              }
            }
          `}
          style={{ bottom: 24 }}
          onClick={() => setVisible(false)}
          icon={
            <CloseIcon
              style={{
                fontSize: "24px",
                color: "white",
                marginLeft: "-2px",
              }}
            />
          }
        />
      )}
      <div
        style={{
          position: "fixed",
          bottom: 24,
          right: visible ? 95 : 24,
          zIndex: 1000,
        }}
        className={css`
          .ant-card {
            padding: 0px !important;
            background: transparent !important;
            backdrop-filter: blur(20px) !important;
            -webkit-backdrop-filter: blur(20px) !important;
          }
          .ant-input {
            background: transparent;
            border: none;
            color: white;
          }
          .ant-input:focus {
            box-shadow: none;
          }
          input::placeholder {
            color: #a8a8a8 !important;
            opacity: 1 !important;
          }
          input::-webkit-input-placeholder {
            color: #a8a8a8 !important;
          }
        `}
      >
        {/* Floating Action Button */}
        {!visible && <SupportUnreadBadge setVisible={setVisible} />}

        {visible && (
          <Card
            bordered={false}
            style={{
              width: 380,
              height: 600,
              borderRadius: 12,
              overflow: "hidden",
              boxShadow: "0 20px 40px rgba(0,0,0,0.6)",
              display: "flex",
              flexDirection: "column",
            }}
            bodyStyle={{
              padding: 0,
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {errorToShow ? (
              <div
                style={{
                  background: `linear-gradient(to bottom, rgba(0,0,0,0.5) 40%, rgba(0,0,0,1) 100%)`,
                  height: "100%",
                  width: 380,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 24,
                  textAlign: "center",
                  color: "white",
                  gap: 16,
                }}
              >
                <Alert
                  message="Support Error"
                  description={errorToShow}
                  type="error"
                  showIcon
                  style={{ width: "100%" }}
                />
                <Button
                  type="primary"
                  style={{
                    backgroundColor: themeDefault?.info?.colorPrimary || "#1890ff",
                    borderColor: themeDefault?.info?.colorPrimary || "#1890ff",
                  }}
                  onClick={() => {
                    setWidgetError(null);
                    if (token) {
                      dispatch(tokenInfoAction(token));
                    }
                  }}
                >
                  Retry
                </Button>
              </div>
            ) : getAllSupportTicketList?.loading || isLoader ? (
              <div
                style={{
                  // background: "rgba(0,0,0,1)",
                  background: `linear-gradient(to bottom, rgba(0,0,0,0.5) 40%, rgba(0,0,0,1) 100%)`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "100%",
                  width: 380,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CustomLoaderIcon size="large" />
              </div>
            ) : view === "menu2" ? (
              <Menu2
                SupportButton={SupportButton}
                handleAction={handleAction}
                setView={setView}
                handleClose={handleClose}
                token={token}
              />
            ) : view === "menu" ? (
              <MainMenu
                setVisible={setVisible}
                setView={setView}
                setIsLoader={setIsLoader}
                token={token}
                SupportButton={SupportButton}
                handleAction={handleAction}
                setActiveTicketId={setActiveTicketId}
                isLoader={isLoader}
              />
            ) : (
              /* Chat View */
              <ChatView
                setView={setView}
                token={token}
                activeCategory={activeCategory}
                isAiResponding={isAiResponding}
                showDummyMessage={showDummyMessage}
                supportMessages={supportMessages}
                setSupportMessages={setSupportMessages}
                isLoader={isLoader}
                setIsLoader={setIsLoader}
                activeTicketId={activeTicketId}
              />
            )}
          </Card>
        )}
      </div>
    </>
  );
};

export default SupportWidget;
